import { AddAssetsToShare } from './AddAssetsToShare';

export default AddAssetsToShare;

